import * as React from "react"

const LocationIcon = (props) => (
  <svg
    width={18}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 0a9.012 9.012 0 0 0-9 9c0 6.461 8.385 14.554 8.741 14.895a.371.371 0 0 0 .518 0C9.615 23.554 18 15.461 18 9a9.012 9.012 0 0 0-9-9Zm0 13.125a4.125 4.125 0 1 1 0-8.25 4.125 4.125 0 0 1 0 8.25Z"
      fill="#EA84AB"
    />
  </svg>
)

export default LocationIcon
